import env from '../../env/env'
import { get } from '../../http/restservice'
import { useEffect, useState } from 'react'
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../../Components/ui/select'
import { Label } from '../../Components/ui/label'
import { Input } from '../../Components/ui/input'
import { Button } from '../../Components/ui/button'

const OneTimeMandate = () => {
  const [mfData, setMFData] = useState()
  const [selectedBasket, setSelectedBasket] = useState()

  let actionPlanUser = sessionStorage.getItem('actionPlanUser')
  const receivedData =
    location.state?.data || (actionPlanUser ? JSON.parse(actionPlanUser)?.data : null)

  const userMFBasket = async () => {
    const url = `${env.API_URL}adminservice/api/actionPlan/getUserMFBaskets`
    let clientCode = receivedData?.uid?.split('-')[0]?.toUpperCase()
    try {
      const response = await get(url, {}, { clientCode })
      setMFData(response?.data?.data)
    } catch (error) {
      console.error(error)
    }
  }

  console.log(mfData, selectedBasket, 'dsfkjdhsfd')

  useEffect(() => {
    userMFBasket()
  }, [])
  return (
    <>
      <div className='border border-black-400 rounded-md max-w-[768px] p-4 mx-auto'>
        <h1>One Time Through Mandate</h1>

        <div>
          <div className='flex gap-x-10 items-center mt-10'>
            <Label>Select a customer basket</Label>
            <Select onValueChange={(val) => setSelectedBasket(val)}>
              <SelectTrigger className='w-[300px] border border-gray-300'>
                <SelectValue placeholder='Select a Basket' />
              </SelectTrigger>
              <SelectContent>
                <SelectGroup>
                  {mfData?.map((item) => {
                    return (
                      <SelectItem
                        key={item.customerBasketInvestmentId}
                        value={item.customerBasketInvestmentId}
                      >
                        {item.customerBasketName}
                      </SelectItem>
                    )
                  })}
                </SelectGroup>
              </SelectContent>
            </Select>
          </div>

          <div className='flex gap-x-10 items-center mt-5'>
            <Label>Enter the Mandate Id</Label>
            <Input type='number' />
          </div>

          <div className='flex gap-x-10 items-center mt-5'>
            <Label>Enter the Amount</Label>
            <Input type='number' />
          </div>
        </div>

        <div className='flex justify-end mt-5'>
          <Button>Submit</Button>
        </div>
      </div>
    </>
  )
}

export default OneTimeMandate
